import { useContext } from 'react';

import { UploadProgressContext } from './upload-progress-context';

export function useUploadProgress(): UploadProgressContextValue {
  const context = useContext(UploadProgressContext);
  if (!context) {
    throw new Error('useUploadProgress must be used within an UploadProgressProvider.');
  }

  return context;
}

type UploadProgressContextValue = NonNullable<React.ContextType<typeof UploadProgressContext>>;
